<div class="container-fluid">
  <div class="mct-flex mct-row mb-4">
    <h1 class="m-0">
      {{ 'profiles.profile-status.profile-status-label' | translate | titlecase }}
    </h1>
    <button app-add-button
      class="btn btn-primary"
      [label]="'profiles.profile-status.add-button' | translate | titlecase"
      (onClick)="newProfileStatus()"
    >
    </button>
  </div>

  <div *ngIf="loadingProfileStatuses" class="text-center py-5">
    <wl-busy [show]="loadingProfileStatuses"></wl-busy>
    <p class="mt-2 text-muted">{{ 'common.loading' | translate | titlecase }}...</p>
  </div>

  <div class="card shadow-none border bg-light p-5 text-center" *ngIf="!loadingProfileStatuses && !profileStatuses?.length">
    <i class="pi pi-info-circle text-muted mb-2" style="font-size: 2rem"></i>
    <p class="m-0">{{ 'profiles.profile-status.no-profile-statuses' | translate | titlecase }}</p>
  </div>

  <div class="card shadow-sm" [hidden]="loadingProfileStatuses || !profileStatuses?.length">
    <p-table [showGridlines]="true"
      #profileStatusDataGrid
      [lazy]="true"
      [rows]="10"
      [value]="profileStatuses"
      [paginator]="true"
      (onLazyLoad)="lazyLoadProfileStatuses($event)"
      [totalRecords]="searchResult.TotalCount"
      styleClass="p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="MemberType1">
            {{ 'profiles.profile-status.profile-status-label' | translate | titlecase }}
            <p-sortIcon field="MemberType1"></p-sortIcon>
          </th>
          <th pSortableColumn="MemberTypeDescr">
            {{ 'profiles.profile-status.descr-label' | translate | titlecase }}
            <p-sortIcon field="MemberTypeDescr"></p-sortIcon>
          </th>
          <th style="width: 220px" class="text-center">
            {{ 'common.actions' | translate | titlecase }}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-status>
        <tr>
          <td class="font-weight-bold">{{ status.MemberType1 }}</td>
          <td>{{ status.MemberTypeDescr }}</td>
          <td class="text-center">
            <div class="mct-flex mct-row mct-gap-10">
              <button
                pButton
                type="button"
                icon="pi pi-pencil"
                class="p-button-text p-button-sm"
                (click)="editProfileStatus(status.ID)"
              ></button>

              <div class="delete-security-group mct-flex mct-row bg-light rounded px-2 border">
                <p-checkbox binary="true" [(ngModel)]="status._canDelete" [title]="'Unlock delete button'"></p-checkbox>
                <button
                  pButton
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-text p-button-danger p-button-sm ml-1"
                  (click)="status._canDelete = false; confirmDeleteProfileStatus(status.ID)"
                  [disabled]="!status._canDelete"
                ></button>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="text-center p-2" *ngIf="isSearching">
      <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
    </div>
  </div>
</div>

<p-dialog
  modal="true"
  #profileStatusModal
  [(visible)]="showStatusModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">
      <i class="pi pi-tag mr-2"></i>
      {{ 'profiles.profile-status.profile-status-label' | translate | titlecase }}
    </h4>
  </ng-template>

  <form novalidate #profileStatusForm="ngForm" class="pt-3">
    <div *ngIf="loadingProfileStatus.busy" class="text-center py-4">
      <wl-busy [show]="loadingProfileStatus.busy"></wl-busy>
    </div>

    <div class="alert alert-danger" *ngIf="loadingProfileStatus.message && !loadingProfileStatus.success">
      <i class="pi pi-exclamation-circle mr-2"></i> {{ loadingProfileStatus.message }}
    </div>

    <div class="container-fluid" *ngIf="!loadingProfileStatus.busy">
      <div class="form-horizontal">
        <div class="form-group row">
          <label class="col-sm-3 col-form-label text-right font-weight-bold">
            {{ 'profiles.profile-status.profile-status-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input
              pattern="^\w(?:.*?\w$)?"
              name="event-type"
              #profileStatusField="ngModel"
              class="form-control"
              type="text"
              [(ngModel)]="selectedProfileStatus.MemberType1"
              required
            />
            <small class="text-danger" *ngIf="profileStatusField?.invalid && profileStatusField.touched">
              {{ 'profiles.profile-status.no-profile-status-error' | translate }}
            </small>
          </div>
        </div>

        <div
          class="alert alert-warning shadow-sm border-warning my-4 mct-flex mct-row"
          *ngIf="profileStatusField.dirty && !creatingNewStatus"
        >
          <p-checkbox binary="true" [(ngModel)]="changeProfiles" name="changeProfilesCheckbox" id="migrateCheck"></p-checkbox>
          <label for="migrateCheck" class="m-0 ml-3 cursor-pointer">
            <strong>{{ 'common.warning' | translate | uppercase }}:</strong>
            {{ 'profiles.profile-status.change-migrate-confirm' | translate }}
          </label>
        </div>

        <div class="form-group row">
          <label class="col-sm-3 col-form-label text-right font-weight-bold">
            {{ 'profiles.profile-status.descr-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <textarea class="form-control" name="descr" rows="3" [(ngModel)]="selectedProfileStatus.MemberTypeDescr"></textarea>
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="savingError">
      {{ savingError }}
    </div>
    <div class="mct-flex mct-row mct-gap-10">
      <wl-busy [show]="saving"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-primary px-4"
        [disabled]="profileStatusForm.invalid || saving"
        (click)="saveProfileStatuses()"
        icon="pi pi-save"
        [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="showStatusModal = false"
        [disabled]="saving"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  modal="true"
  #confirmDeleteProfileStatusModal
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [showHeader]="false"
>
  <div class="p-4 text-center">
    <div class="rounded-circle bg-danger-light d-inline-flex p-3 mb-3">
      <i class="pi pi-exclamation-triangle text-danger" style="font-size: 2.5rem"></i>
    </div>

    <h4 class="font-weight-bold mb-3">{{ 'common.delete' | translate | titlecase }} Status</h4>

    <p class="text-muted">
      {{ 'profiles.profile-status.delete-migrate-confirm' | translate }}
    </p>

    <div class="form-group text-left mt-4">
      <label class="small font-weight-bold text-uppercase">Migrate existing profiles to:</label>
      <select class="form-control form-control-lg" [(ngModel)]="profileStatusToMigrateTo">
        <option [ngValue]="null">-- Do Not Migrate (None) --</option>
        <option *ngFor="let status of getAllButOneProfileStatus()" [ngValue]="status">
          {{ status.MemberType1 }}
        </option>
      </select>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="deleteError">
      {{ deleteError }}
    </div>
    <div class="mct-flex mct-row mct-gap-10 pb-3">
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-danger px-4"
        (click)="deleteMigrateProfileStatus()"
        [disabled]="deleting"
        icon="pi pi-trash"
        [label]="(deleting ? 'profiles.profile-status.delete-migrating' : 'profiles.profile-status.delete-migrate') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="showDeleteModal = false"
        [disabled]="deleting"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
